package com.cybersoftsolution.cybersoftsolutionweb.models



data class CollapseQuestions(override var id: String?, override var text: String, var question: String, var answer: String):MyElement()

var collapseQuestions = listOf(



    CollapseQuestions(
        id = "aboutUsFAQ",
        text  = "Quiénes Somos",
        question = "¿Qué es Cyber Soft Solution?",
        answer = """
        Cyber Soft Solution es una empresa dedicada al desarrollo de software personalizado, enfocada en 
        crear soluciones tecnológicas innovadoras que impulsan el crecimiento de negocios en diversas industrias. 
        No nos limitamos a escribir código; nos sumergimos en la comprensión profunda de las necesidades de cada 
        cliente para diseñar y construir software que se adapte perfectamente a sus procesos y objetivos. 
        Ofrecemos una amplia gama de servicios, desde el desarrollo web y móvil hasta soluciones más complejas 
        que involucran inteligencia artificial, análisis de datos e integración de sistemas.
                """.trimIndent()
    ),

    CollapseQuestions(
        id = "whyChooseUsFAQ",
        text  = "Por que Elegirnos",
        question = "¿Por qué Cyber Soft Solution?",
        answer = """
        Porque sin lugar a dudas más que una empresa de desarrollo de software; somos un socio estratégico que ayuda a las empresas y personas 
        a transformar sus ideas en realidad a través de la tecnología. Buscamos construir relaciones a largo plazo con 
        nuestros clientes, basadas en la confianza, la transparencia y el compromiso, eligenos y busquemos juntos el éxito.
                """.trimIndent()
    ),

    CollapseQuestions(
        id = "focousFAQ",
        text  = "Enfoque",
        question = "¿Qué hace a Cyber Soft Solution diferente de otras empresas de desarrollo de software?",
        answer = """
        En Cyber Soft Solution, no solo construimos software; creamos experiencias digitales transformadoras. 
        Brindamos consultoría y desarrollo de soluciones integrales, hemos ganado las habilidades necesarias 
        para resolver desafíos complejos y ofrecer soluciones innovadoras. Nos diferenciamos por un enfoque 
        centrado en la innovación continua y la colaboración. Priorizamos la comunicación para lograr un 
        entendimiento profundo de tus objetivos, desde la concepción de la idea hasta el soporte y el 
        mantenimiento continuo. De ser necesario trabajamos codo a codo contigo en cada etapa del proyecto, 
        desde el análisis y la planificación hasta la implementación y el soporte, 
        asegurando que la solución final se ajuste perfectamente a tus necesidades
                """.trimIndent()
    ),
    CollapseQuestions(
        id = "servicesFAQ",
        text  = "Servicios",
        question = "¿Qué tipo de servicios de desarrollo de software ofrecen?",
        answer = """
        Diseñamos desde cero Sitios Web atractivos y funcionales que impulsan tu presencia online y aportan valor a tu negocio.
        Desarrollamos aplicaciones multiplataforma que conectan con tus clientes en cualquier lugar.
        Creamos software de escritorio robusto y seguro que optimizan tus procesos internos. Y por último, pero no menos importante
        Implementamos soluciones para servidores escalables y de alto rendimiento que sustentan tu infraestructura tecnológica.
                """.trimIndent()
    ),

    CollapseQuestions(
        id = "processFAQ",
        text  = "Procesos",
        question = "¿Cuál es el proceso que siguen desde la solicitud inicial hasta la entrega del proyecto?",
        answer = """
        Consulta Inicial: Entendemos tus necesidades y objetivos.
        Análisis y Planificación: Definimos el alcance del proyecto y creamos un plan detallado.
        Desarrollo: Construimos la solución utilizando las últimas tecnologías.
        Pruebas y Control de Calidad: Aseguramos la calidad y el correcto funcionamiento del software.
        Implementación y Despliegue: Lanzamos la solución y te brindamos el soporte necesario.
        Soporte y Mantenimiento Continuo: Ofrecemos soporte técnico y mantenimiento para asegurar el óptimo rendimiento a largo plazo.
                """.trimIndent()
    ),
    CollapseQuestions(
        id = "technologiesFAQ",
        text = "Tecnologías",
        question = "¿Con qué tecnologías trabajan?",
        answer = """
        La respuesta mas corta seria "Todas las necesarias" por eso nos gusta mantenemos a la vanguardia de las últimas tecnologías 
        y tendencias del mercado para ofrecerte soluciones innovadoras y eficientes.Siendo un poco mas especifica podemos decir que 
        trabajamos con una variedad de lenguajes de programación, frameworks y plataformas, adaptándonos a las necesidades de cada proyecto. 
        Algunas de las tecnologías que solemos utilizar incluyen (pero no se limitan a) 
        [Java, Kotlin, React, Angular, Node.js, JavaScript, Python, SQL/noSQL, C#, C++, Go, TScript, Swift, Ktor, Spring, .NET, 
        Flutter, AWS, Azure, GCP, Cloudflare, Heroku, Salesforce , VS Code, IntelliJ, Visual Studio, Android Studio, Xcode, MySQL, 
        PostgreSQL, MongoDB, Firebase y un largo etc.] nos gusta estar en constante aprendizaje y tenemos un equipo de profesionales tan 
        valioso como la comunidad que nos ayuda a mejorar constantemente.
                """.trimIndent()
    ),
    CollapseQuestions(
        id = "supportFAQ",
        text = "Soporte y Mantenimiento",
        question = "¿Qué tipo de soporte y mantenimiento ofrecen después de la entrega del proyecto?",
        answer = """
        En Cyber Soft Solution, nuestro compromiso no termina con la entrega del proyecto. Ofrecemos un soporte técnico integral 
        y un mantenimiento continuo para asegurar el óptimo funcionamiento de tu software a lo largo del tiempo. Esto incluye la 
        resolución de errores, actualizaciones de seguridad, mejoras de rendimiento y la adaptación a nuevas necesidades que puedan surgir.
                """.trimIndent()
    ),

    CollapseQuestions(
        id = "comunicationFAQ",
        text = "Comunicación y Seguimiento",
        question = "¿Cómo me mantendrán informado sobre el progreso del proyecto y cómo puedo comunicarme con su equipo?",
        answer = """
        La comunicación transparente es fundamental para nosotros. Utilizamos herramientas de gestión de proyectos para el seguimiento del progreso 
        y te proporcionamos actualizaciones periódicas a través de los canales de comunicación que estimes convenientes, por ejemplo: reuniones virtuales, 
        informes semanales, correo electrónico, etc, Todo dependera de tu preferencia y la escala de tu proyecto. Además, tendrás un punto de contacto 
        dedicado que estará disponible para responder a tus preguntas y resolver cualquier duda que puedas tener.
                """.trimIndent()
    ),
    CollapseQuestions(
        id = "copyrightFAQ",
        text  = "Propiedad Intelectual",
        question = "¿Cuál es su política de propiedad intelectual?",
        answer = """
        La propiedad intelectual es un tema importante. Por lo general, acordamos con nuestros clientes la cesión de los derechos 
        de propiedad intelectual del código fuente y otros materiales desarrollados, a menos que se acuerde lo contrario en el contrato. 
        Nos aseguramos de que todo quede claramente establecido desde el inicio del proyecto.
                """.trimIndent()
    ),

    CollapseQuestions(
        id = "qualityFAQ",
        text  = "Calidad del Software",
        question = "¿Qué medidas toman para garantizar la calidad del software que desarrollan?",
        answer = """
        La calidad es una prioridad en cada etapa del desarrollo. Implementamos procesos de control de calidad rigurosos, 
        que incluyen pruebas unitarias, pruebas de integración, pruebas de rendimiento y pruebas de seguridad. Seguimos 
        metodologías ágiles y nos aseguramos de que el software cumpla con los más altos estándares de calidad y rendimiento.
                """.trimIndent()
    ),

    CollapseQuestions(
        id = "changesFAQ",
        text  = "Gestión de Cambios",
        question = "¿Cómo manejan las solicitudes de cambio o modificaciones durante el proceso de desarrollo?",
        answer = """
        Entendemos que los requisitos pueden evolucionar a lo largo del proyecto. Contamos con un proceso de gestión de cambios 
        flexible que nos permite adaptarnos a tus necesidades. Analizamos el impacto de los cambios solicitados y te proporcionamos 
        una estimación del tiempo y el costo adicionales, garantizando la transparencia y el control del proyecto.
                """.trimIndent()
    ),

    CollapseQuestions(
        id = "experienceFAQ",
        text  = "Experiencia Relevante",
        question = "¿Tienen experiencia en el desarrollo de software para mi industria o con proyectos similares a lo que necesito?",
        answer = """
        Entendemos que la experiencia específica es crucial. Contamos con un portafolio diverso que abarca diferentes industrias, 
        incluyendo [ Comercio Electrónico (E-commerce), Salud, Finanzas, Manufactura, Logística, Transporte, Educación, Redes Sociales , 
        Contratacion , Entretenimiento, Telecomunicaciones, Sector Público, Startups Tecnológicas, Empresas en Crecimiento, 
        Negocios con Necesidades Específicas, etc. ] Nos adaptamos a las necesidades de cada sector, asegurando soluciones 
        que cumplen con los estándares y regulaciones específicas.
                """.trimIndent()
    ),


    )

